module.exports = __webpack_public_path__ + "img/menu_result.951246d6.webp";